import React, { useState } from 'react';
import { referalCodeApi } from '../../../../services/referalCode';

const useReferal = () => {
  const [loading, setLoading] = useState(false);
  const [referalcode, setReferalCode] = useState();

  const getReferalcode = async () =>{
    setLoading(true);
    try {
      let response = await referalCodeApi();
      if (response) {
        setReferalCode(response.referral_code);
        setLoading(false);
      } else {
        setLoading(false);
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      setLoading(false);
    }
  }
  return {
    loading,
    referalcode,
    getReferalcode
  };
};

export default useReferal;
